












import { Component, Vue } from "vue-property-decorator";
import HotelName from "./hotel-name.vue";
import StandartModal from "@/components/app/standart-modal.vue";
import { configuration } from "@/config/host.config";
import { IHotelConfig } from "@/@types/filoxenia-config/tv-config";
import { ILocale } from "@/@types/locale";

@Component({ components: { StandartModal, HotelName } })
export default class HotelConfiguration extends Vue {
  mmsi: string | undefined;
  hotel_name: ILocale | null = null;

  async createConfigurationHotel(): Promise<void> {
    try {
      const config = { params: { "match[app]": "hotel" } };
      const res = await this.$axios.get(configuration.mainAPI, config);
      if (res.status === 200) {
        if (res.data.hotel.mmsi) this.mmsi = res.data.hotel.mmsi;
        if (res.data.hotel.hotel_name)
          this.hotel_name = res.data.hotel.hotel_name;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async updateConfig(data: Partial<IHotelConfig>): Promise<void> {
    try {
      const config = { params: { app: "hotel" } };
      const configRes = await this.$axios.put(
        configuration.mainAPI,
        data,
        config
      );
      if (configRes.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.createConfigurationHotel();
      } else
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.createConfigurationHotel();
  }
}
